import { CSSProperties } from 'react';

export const getFontSize = (
  isVerticalMode: boolean
): CSSProperties['fontSize'] => (isVerticalMode ? '12px' : '14px');
